import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { StateService } from '../../shared/services/state-service';
import { IMenuItems } from '../../shared/model/menuItems';
import { UserRole } from '../../shared/model/role';
import { RouterLinkWithHref, Router, RouterLinkActive } from '@angular/router';
import { Image } from '../../shared/components/image/image';
import { Button } from '../../shared/components/button/button';
import { ThemeService } from '../../core/services/theme-service';
import { Sidebarservice } from '../../shared/services/sidebarservice';
import { NAVIGATION } from '../../core/navigation/navigation.config';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLinkWithHref, Button, RouterLinkActive],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar implements OnInit {
  stateService = inject(StateService);
  private router = inject(Router);
  themeService = inject(ThemeService);
  private destroyRef = inject(DestroyRef);
  private sidebarService = inject(Sidebarservice);

  @Input() isOpen = true;

  @Output() toggle = new EventEmitter<void>();

  role: UserRole = UserRole.USER;
  menuItems: IMenuItems[] = [];
  // activeRoute = signal('');
  activeMenu = this.sidebarService.activeMenu;
  navItems = NAVIGATION();




  ngOnInit() {
    this.role = this.sidebarService.getRole();
    this.menuItems = this.sidebarService.getmenuItems();
    // this.activeRoute.set(this.router.url);
    console.log('this.router.url', this.router.url);
    console.log('this.activeMenu()?.route', this.activeMenu()?.route);
    // this.syncActiveRouteWithRouter()
  }


  onToggle() {
    this.toggle.emit();
  }

  closeSidebar(): void {
    if (window.innerWidth < 991) {
      this.stateService.sidebarOpen.set(false);
    }
  }
  onNavigate() {
    // this.activeMenu.set(item);
    // this.activeRoute.set(item.route);
    // this.sidebarService.activeMenu.set(item)
    // this.closeSidebar();
    this.stateService.sidebarOpen.set(false);
  }

  logout(): void {
    localStorage.clear();
    this.stateService.setUserLoggedIn(false);
    this.router.navigate(['/login']);
  }

  // syncActiveRouteWithRouter() {
  //   this.router.events
  //     .pipe(
  //       filter(
  //         e =>
  //           e instanceof NavigationEnd ||
  //           e instanceof NavigationCancel ||
  //           e instanceof NavigationError
  //       ),
  //       takeUntilDestroyed(this.destroyRef)
  //     )
  //     .subscribe({
  //       next: () => {
  //         // this.activeRoute.set(this.router.url);
  //         console.log("this.router.url", this.router.url)
  //         console.log("this.activeMenu()?.route", this.activeMenu()?.route)
  //       }
  //     });
  // }

  onClose() {
    this.stateService.closeSidebar();
  }
}
